import * as React from 'react';
import styled from 'styled-components';

import { GlassPane } from '@longline/aqua-ui/containers/GlassPane';

interface IProps {
  /** @ignore */
  children?: React.ReactNode;
}

const OrganixStatus = (props: IProps) => 
  <ReportHolder>
    <GlassPane bordered>
      <ReportInner>
        {props.children}
      </ReportInner>
    </GlassPane>
  </ReportHolder>

const ReportHolder = styled.div`
  position: absolute;
  bottom: 100px;
  left: 50%;
  translate: -50% 0%;
  border-radius: 20px;
  min-width: 250px;
  max-width: 600px;
  z-index: 1000;
`

const ReportInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
`

export { OrganixStatus }
